import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BodyCopy } from '@xingternal/typography';
import { Row } from '@xingternal/xing-grid';

import { ShowMore } from '@/components/show-more';
import { useBreakpoints } from '@/hooks';

import styles from './withShowMoreInMobile.css';

const MAX_PREVIEW_HEIGHT = 600;

const showMoreText = (translationKey) => (
  <BodyCopy size="medium" fontWeight="bold" noMargin>
    <FormattedMessage id={translationKey} />
  </BodyCopy>
);

const withShowMoreInMobile = (Component) => (props) => {
  const ref = React.useRef();
  const [height, setHeight] = React.useState(0);

  const { isMobile } = useBreakpoints();
  const showPreview = isMobile && height > MAX_PREVIEW_HEIGHT;

  React.useEffect(() => {
    ref.current && setHeight(ref.current.scrollHeight);
  }, []);

  return showPreview ? (
    <ShowMore
      className={styles.toggle}
      textCollapsed={showMoreText('BUTTON_MORE')}
      textExpanded={showMoreText('BUTTON_LESS')}
      collapsedHeight={MAX_PREVIEW_HEIGHT}
      showBorder={false}
    >
      <Row>
        <Component {...props} />
      </Row>
    </ShowMore>
  ) : (
    <div ref={ref} className={styles.container}>
      <Component {...props} />
    </div>
  );
};

export default withShowMoreInMobile;
